import React, { useCallback, useContext, useMemo, useState } from 'react';
import { makeStyles } from '@mui/styles';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { TextField } from '@mui/material';
import { withStyles } from '@mui/styles';
import { Share } from '@mui/icons-material';
import { PartnerContext } from '../../lib/contexts';
import { ThemeContext } from '../../lib/contexts/ThemeContext';

const useStyles = makeStyles((theme) => ({
  form: {
    display: 'flex',
    flexDirection: 'column',
    margin: 'auto',
    width: 'fit-content',
    '& svg': {
      marginBottom: -6,
      marginRight: 4,
    },
    '& input': {
      borderColor: theme.palette.admin.main,
    },
  },
  formControl: {
    marginTop: theme.spacing(2),
    minWidth: 120,
  },
  formControlLabel: {
    marginTop: theme.spacing(3),
    marginLeft: 0,
    '& svg': {
      marginBottom: -6,
    },
  },
  addPatientList: {
    backgroundColor: theme.palette.admin.main,
    color: theme.palette.admin.light,
    width: 214,
    height: 50,
    padding: 0,
    '&:hover': {
      backgroundColor: theme.palette.admin.dark,
      color: theme.palette.admin.light,
    },
  },
  progressBar: {
    display: 'block',
    margin: '50px auto 50px',
    backgroundColor: theme.palette.admin.light,
  },
  progressBarColor: {
    backgroundColor: theme.palette.admin.main,
  },
  shareSwitch: {
    color: theme.palette.admin.main,
  },
  cancelButton: {
    color: theme.palette.error.main,
  },
  addButton: {
    color: theme.palette.admin.main,
  },
}));

const AdminGreenTextField = withStyles((theme) => ({
  root: {
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: theme.palette.admin.main,
      },
      '&:hover fieldset': {
        borderColor: theme.palette.admin.main,
      },
      '&.Mui-focused fieldset': {
        borderColor: theme.palette.admin.main,
      },
    },
  },
}))(TextField);

const ShareLinkDialog = ({ handleClose, link }) => {
  const classes = useStyles();
  const {
    state: { code: partnerCode },
  } = useContext(PartnerContext);

  const {
    state: { finalTheme, darkMode },
  } = useContext(ThemeContext);

  const [copied, setCopied] = useState(false);
  const shareURL = useMemo(() => link ?? 'https://' + partnerCode + '.dietid.com', [partnerCode, link]);

  const copyTextToClipboard = useCallback(async () => {
    if ('clipboard' in navigator) {
      return await navigator.clipboard.writeText(shareURL);
    } else {
      return document.execCommand('copy', true, shareURL);
    }
  }, [shareURL]);

  const handleCopy = () => {
    // Asynchronously call copyTextToClipboard
    copyTextToClipboard()
      .then(() => {
        // If successful, update the isCopied state value
        setCopied(true);
        setTimeout(() => {
          setCopied(false);
        }, 1500);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <>
      <Dialog
        maxWidth={'sm'}
        fullWidth={true}
        open={true}
        onClose={handleClose}
        aria-labelledby="share-dialog-title"
        className={classes.form}
      >
        <DialogTitle
          id="share-dialog-title"
          style={{ color: darkMode ? 'white' : 'black' }}
        >
          <Share /> {copied ? 'Share URL Copied!' : 'Share URL'}
        </DialogTitle>
        <DialogContent>
          <>
            <DialogContentText style={{ color: darkMode ? 'white' : 'black' }}>
              Copy & Share your Diet ID Assessment URL below:
            </DialogContentText>
            <form noValidate>
              <AdminGreenTextField
                variant={'outlined'}
                fullWidth={true}
                value={shareURL}
                InputProps={{
                  style: {
                    color: darkMode ? 'white' : 'black',
                  },
                }}
                style={{
                  '& .MuiOutlinedInput-root': {
                    '& fieldset': {
                      borderColor: darkMode ? 'white' : 'black',
                    },
                  },
                }}
              />
            </form>
          </>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleClose}
            className={classes.cancelButton}
            style={{ color: darkMode ? 'white' : 'black' }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleCopy}
            className={classes.addButton}
            style={{ color: darkMode ? 'white' : 'black' }}
          >
            Copy URL
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
export default ShareLinkDialog;
